var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-top-button"},[_c('a',{staticClass:"scroll-top-button__button",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleScroll.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.$t('ui.buttons.back_to_top'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }